import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
  //弹框
  layerState:false,
  layerMsg:'',

  //长连接
  ws:null,
  wsData:[],

  //标题栏
  barState:false,
  barTitle:'',

  webscoketObj: null,//长连接对象
  webscoketData: [],//长连接数据
  minLineData: [],
  kLineData: [],//K线数据
  lastVolume: 0,
  //chooseTimeParams: 1,
  chooseTimeType: 'D',//K线时间类型
  yesterdayClose: 0,
  webscoketConfigStr: '',
  inputBoxOnOff:false
}
//对数据的操作
const mutations = {

  //弹框
  layer(state,data) {
    state.layerState = true
    state.layerMsg = data
  },
  layerColose(state,data) {
    state.layerState = false
  },

  //长连接
  setWs(state,ws) {
    state.ws = ws
  },
  wsSend(state,data){
    state.ws.send(JSON.stringify(data))
  },
  setWsData(state,data) {
    state.wsData = data
  },

  //标题栏
  setBar(state,arr) {
    state.barState = arr[0]
    state.barTitle = arr[1]
  },

  
  setWebsocketObj(state, webscoketObj) {
    state.webscoketObj = webscoketObj
  },
  setWebscoketData(state, allData) {
    state.webscoketData = allData
  },
  setMinLineData(state, dataObj) {
    let minLineData = []
    let data = dataObj.data
    if (parseInt(data.fid) === parseInt(dataObj.fid)) {
      minLineData = [
        (data.sec_time - (data.sec_time % 60)) * 1000,
        parseFloat(data.last_price),
        parseFloat(data.volume_inc),
        parseFloat(data.position),
        parseFloat(state.yesterdayClose),
        parseFloat(data.open_price)
      ] //将时间戳转换成整分钟毫秒级
    }
    state.minLineData = minLineData
  },
  setKlineLastVolume(state, lastVolume) {
    state.lastVolume = lastVolume
  },
  setKLineData(state, dataObj) {
    let kLineData = []
    let data = dataObj.data
    if (parseInt(data.fid) === parseInt(dataObj.fid)) {
      let getVolume = () => {
        let volume = 0
        if (state.chooseTimeType === 'D') {
          volume = data.volume
        } else {
          volume = data.volume_inc
        }
        return volume
      }
      kLineData = [
        (data.sec_time - (data.sec_time % 60)) * 1000,
        parseFloat(data.open_price),
        parseFloat(data.high_price),
        parseFloat(data.low_price),
        parseFloat(data.close_price),
        getVolume(),
        parseFloat(data.today_settlement),
        parseFloat(data.yestoday_settlement),
        parseFloat(data.position)
      ] //将时间戳转换成整分钟毫秒级
    }
    state.kLineData = kLineData
  },
  /*setChooseTimeParams(state, ChooseTimeIndex) {
    state.chooseTimeParams = ChooseTimeIndex
  },*/
  setChooseTimeType(state, type) {
    state.chooseTimeType = type
  },
  setYestodayClose(state, yesterdayClose) {
    state.yesterdayClose = yesterdayClose
  },
  setWebscoketConfigStr(state, webscoketConfigStr) {
    state.webscoketConfigStr = webscoketConfigStr
  },
  setInputBoxOnOff(state) {
    state.inputBoxOnOff = !state.inputBoxOnOff
  }
}

export default new Vuex.Store({
  state,
  mutations
})



// WEBPACK FOOTER //
// ./src/store/index.js